module.exports = __webpack_public_path__ + "static/media/boton_sonido.46d56dde.bin";